import LoginContainer from './containers/LoginContainer'

export default {
  path : '/login',
  components : { main:LoginContainer, category:null }
}



// WEBPACK FOOTER //
// ./src/routes/Login/index.js